module.exports = __webpack_public_path__ + "static/media/logo2.d15e18df.svg";